<!--
  树形选择框
    已经实现的功能：
    - v-model吐出数据
    - 数据字段转换（与展示相关的字段）
    - 选中展示及placeholder
    - 重置选中树
    - 默认选中
-->
<template>
  <div class="tree-select" id="tree-select">
    <lk-poptip class="tree-select-poptip" width="256" placement="bottom" v-if="isShow">
      <lk-tooltip placement="top" :disabled="treeSelectLabel.length === 0" max-width="256" :transfer="true">
        <div slot="content">
          <p class="tree-select-label-content">{{treeSelectLabel}}</p>
        </div>
        <lk-input
          class="item"
          :value="treeSelectLabel"
          readonly
          clearable
          :placeholder="placeholder"
          @on-change="handleChange">
        </lk-input>
      </lk-tooltip>
      <div class="treeFormat" slot="content">
        <lk-tree
          ref="treeSelect"
          :data="dataList"
          show-checkbox
          multiple
          @on-check-change="handleCheckChange">
        </lk-tree>
        <div class="tree-select-footer">
          <lk-button class="mr5" type="text" size="small" @click="handleSelectHide">取消</lk-button>
          <lk-button class="mr5" type="warning" size="small" @click="handleResetTree">重置</lk-button>
          <lk-button type="primary" size="small" @click="handleSelectOk">确定</lk-button>
        </div>
      </div>
    </lk-poptip>
  </div>
</template>

<script>
import utils from '../../libs/utils';

export default {
  name: 'treeSelect',
  props: {
    data: { // 树形数据源
      type: Array,
      default() {
        return [];
      },
    },
    props: { // 数据转换 避免字段不匹配
      type: Object,
      default() {
        return {
          title: 'title',
          value: 'value',
          children: 'children',
        };
      },
    },
    value: { // model
      type: Array,
      default() {
        return [];
      },
    },
    placeholder: {
      type: String,
      default: '',
    },
    isOnlyLeaf: { // 只需要叶子节点
      type: Boolean,
      default: true,
    },
  },
  model: {
    prop: 'value',
    event: 'handle',
  },
  watch: {
    data(newVal) {
      this.transData(newVal);
    },
    value: {
      handler(newVal) {
        this.currentValue = newVal;
        if (newVal.length === 0) {
          this.handleResetTree();
        } else {
          this.setDefaultValue();
        }
      },
      deep: true,
    },
    currentValue(newVal) {
      this.$emit('handle', newVal);
    },
  },
  data() {
    return {
      dataList: [], // 数据列表
      treeSelectLabel: '', // 回显的数据
      isShow: true, // 是否展示树形列表
      currentValue: this.value,
    };
  },
  methods: {
    // 转换数据
    transData(data) {
      this.dataList = this.getTree(data);
    },
    // 生成树形所需的结构
    getTree(tree = []) {
      const arr = [];
      if (!!tree && tree.length !== 0) {
        tree.forEach((item) => {
          const obj = {};
          obj.title = item.title || item[this.props.title];
          obj.value = item.value || item[this.props.value];
          obj.expand = false;
          obj.selected = false;
          obj.checked = false;
          obj.children = this.getTree(item[this.props.children]); // 递归调用
          arr.push(obj);
        });
      }
      return arr;
    },
    handleResetTree() {
      const nodes = this.$refs.treeSelect.getCheckedNodes();
      nodes.forEach((item) => {
        item.checked = false;
        item.selected = false;
        this.treeSelectLabel = '';
        this.$emit('handle', []);
      });
      this.dataList = this.getTree(utils.deepClone(this.dataList));
    },
    // 选好了，吐出数据
    handleSelectOk() {
      const nodes = this.$refs.treeSelect.getCheckedNodes();
      const treeLabel = []; // 选择成功后展示的文本
      const treeValue = []; // 选择成功后展示的值
      nodes.forEach((item) => {
        if (this.isOnlyLeaf) {
          if (item.children.length === 0) {
            treeLabel.push(item.title);
            treeValue.push(item.value);
          }
        } else {
          treeLabel.push(item.title);
          treeValue.push(item.value);
        }
      });
      this.treeSelectLabel = treeLabel.join(', '); // 展示文本
      this.$emit('handle', treeValue); // 同步到model
      this.handleSelectHide(); // 关闭树
    },
    // 默认选中
    setDefaultValue() {
      const treeLabels = [];
      const setTreeLabel = (dataList) => {
        dataList.forEach((item) => {
          if (item.children && item.children.length > 0) {
            setTreeLabel(item.children);
          }
          const flag = !!this.value.includes(item.value);
          if (flag) {
            treeLabels.push(item.title);
          }
          item.checked = flag;
        });
      };
      setTreeLabel(this.dataList);
      this.treeSelectLabel = treeLabels.join(', ');
    },
    // 点击树形菜单的复选框时触发
    handleCheckChange(checkedItem) {
      this.$emit('on-check-change', checkedItem);
    },
    /*
    * 显隐组件
    * 由于点击确认的时候需要关闭tree-select，但是poptip没有单独提供显隐开关，所以增加isShow用来控制
    * */
    handleSelectHide() {
      this.isShow = false;
      this.$nextTick(() => {
        this.isShow = true;
      });
    },
    handleChange() {
      this.handleResetTree();
    },
  },
  created() {
    // 转换数据
    this.transData(this.data);
  },
};
</script>

<style scoped>
/* .tree-select {
} */
.mr5 {
  margin-right: 5px;
}

.tree-select-footer {
  text-align: right;
  margin: 5px 0;
}
</style>
